import { pino } from 'pino';
import { config, isProductionEnvironment } from './config.js';
export const logger = pino({
    level: isProductionEnvironment() ? 'error' : 'trace',
    transport: {
        target: 'pino-pretty',
        options: config.environment.stage === 'development'
            ? {
                colorize: true,
            }
            : {
                colorize: false,
                ignore: 'time,pid,hostname',
            },
    },
});
